"use client";

import Checkbox from "@/components/atoms/FormComponents/Checkbox";
import Input from "@/components/atoms/FormComponents/Input/Input";
import Select from "@/components/atoms/FormComponents/Select";
import SubmitButton from "@/components/atoms/FormComponents/SubmitButton";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import cn from "clsx";
import styles from "./LandingForm.module.scss";
import { trackingDetails } from "@/api/getOtherFormDetails";
import { usePathname } from "next/navigation";
import { COUNTRY_CALLING_CODES } from "@/helpers/constants";
import { useOTPContext } from "@/components/sections/CommonModals/context";
import { EXPERIENCE_LIST, getProgramId, getSpecializationValue } from "../../components/molecules/Forms/LandingPageConnectModalForm/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import { StorageService } from "@/helpers/storage.service";
import ApplicationFormRedirectLoader from "../../components/molecules/ApplicationFormRedirectLoader/ApplicationFormRedirectLoader";
import { useInView } from "react-intersection-observer";
import { ModalContext } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import useOnScreen from "@/helpers/Onscreen";
import Markdown from "@/components/atoms/Markdown";
import { getGlobalStateValue, updateStateSession, fetchIpInfoFunNew, ALL_COUNTRIES } from "@/context/utils";
import { disabledButtonPaths } from "../../components/molecules/Forms/LandingPageConnectModalForm/utils";
import ConsentFormPara from "@/components/common/utils/consentFormPara";
import ThankyouForInterestSection from "../../components/molecules/Forms/LandingPageConnectModalForm/Thankyou";
import { useIpStackDetails } from "@/helpers/useIpStackDetails";
import CountryDropdownGlobal from "@/components/atoms/FormComponents/CustomDropdownGlobal/CustomDropdownGlobal";


const errorAccordingToFieldName = {
    fullName: "Please enter valid full name",
    countryCode: "Please enter valid country code",
    phoneNumber: "Please enter valid phone number",
    emailId: "Please enter valid email address",
    isTermsAccepted: "Please accept terms & conditions",
    workExperience: "Please select experience",
};

const countryCodeOptions = COUNTRY_CALLING_CODES;


const getCssConfig = () => ({
  formWrapper: "h-[100%]",
  firstName: cn(styles.inputWrapper, "flex gap-4"),
  phoneNumber: cn(styles.commonMargins),
  email: cn(styles.commonMargins, styles.emailContainer, "flex gap-4"),
  termsConditions: cn(styles.commonMargins, "flex items-start gap-[17px]"),
});

export default function LandingConnectModalForm(props: {
    // handleSubmit?: any;
    ProgramId?: any;
    associatedPrograms : Array<ProgramDetails>
    isNewLeadForm?: boolean
    NewBannerUI?: NewBannerUI
    isMobile?: boolean;
    isWebinar?: boolean;
    slug?:string
    isModal?:boolean
}) {
    const path = usePathname();
    const disabledButton = disabledButtonPaths.includes(path)
    const isCampusImmersionPage = path == "/lp-nw/mba-campus-immersion-online";
    const isAfricaPage = path == "/africa";
    const {ipStackDetails,countryCode} = useIpStackDetails(isAfricaPage);  
    const webinarId = typeof props.slug === 'string' ? props.slug.split('/').pop() : '';
   
    const [message, setMessage] = useState(null);
    const [isLoading, loading] = useState(false);
    const { handleSendOTP, isOTPLoading, setShowLoader, setLeadResponse, setIsHeaderHidden, setIsNewSignInFlow, isHeaderHidden } = useOTPContext();

    const [ isThankYouBannerHidden, setIsThankYouBannerHidden] = useState(true)

    const [formValues, setFormValues] = React.useState({
        fullName: "",
        countryCode: disabledButton ? "+91": countryCode,
        phoneNumber: "",
        emailId: "",
        programId: props.ProgramId,
        isTermsAccepted: true,
        workExperience: ""
    });
    const [errors, setErrors] = React.useState({
        fullName: "",
        countryCode: "",
        phoneNumber: "",
        emailId: "",
        programId: "",
        isTermsAccepted: "",
        workExperience: ""
    });

    const { modalDispatch } = useContext(ModalContext)
    const isSessionModalActive = StorageService.get("timeConnectModal")

    const ref = useRef()
    const {ref: formRef, inView} = useInView();
    const setRefs = useCallback(
      (node) => {
        ref.current = node;
        formRef(node);
      },
      [formRef],
    );

    const onScreen = useOnScreen(ref)  

    useEffect(() => {
        setFormValues((prev) => ({
          ...prev,
          countryCode: countryCode,
        }));
    }, [ipStackDetails]);

    useEffect(() => {
      updateStateSession({
        formSectionName : "Download Brochure"
      })
    }, []);

    useEffect(()=>{
      const enrollNowRef = document.getElementById('enroll-now-cta')
      
      if(enrollNowRef) {
        if(onScreen){
          enrollNowRef.style.display = "none";
        }else{
          enrollNowRef.style.display = "block";
        }
      }  
      
    }, [onScreen])
    
  useEffect(() => {
    if(!isSessionModalActive){
      modalDispatch({
        type: IModalActions.UpdateModal,
        data: { 
          modalType: ModalTypes.CallUsModal, 
          isModalOpen: false, 
          isModalForceClose: inView 
        }
      });
    }
  }, [inView]);

  useEffect(()=>{
    setIsNewSignInFlow(true)
  },[])


    const [isFormValid, setIsFormValid] = React.useState(false);
    const [loadingCount, setLoadingCount] = React.useState(3);
    const [isApplicationRedirectLoaderDisabled, setApplicationRedirectLoaderDisabled] =
      useState(true);
    const Custom10Value = props?.associatedPrograms[0]?.attributes?.BasicDetails?.Custom10PgType;

    const counterInterval = useRef(null);
    
    const { CTABackgroundColorMobile, CTABackgroundColorDesktop, CTAColorMobile, CTAColorDesktop } =
      props.NewBannerUI || {};

    const btnColors ={
        bg: props.isMobile ? CTABackgroundColorMobile: CTABackgroundColorDesktop,
        color: props.isMobile ? CTAColorMobile: CTAColorDesktop
      }

    const apiResponseURL = useRef(null)

    const cssConfig = getCssConfig()

    const regexForInputs: any = {
        fullName: /^[a-zA-Z][a-zA-Z ]{2,49}$/,
        countryCode: /^\+(?:[0-9]?){6,14}[0-9]$/,
        phoneNumber: /^[1-9][0-9]{9}$/,
        emailId: /^(?!.*\.\.)[a-zA-Z0-9](\.?[a-zA-Z0-9_-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
        isTermsAccepted: /^true$/,
        workExperience: new RegExp("^(" + EXPERIENCE_LIST.slice(1,EXPERIENCE_LIST.length + 1).join("|") + ")$")
    };

    // If country code is +91 then only allow 10 digits else allow 7-13 digits
    const handlePhoneNumberChange = (
        value: string,
        countryCodeVal: string = formValues.countryCode
    ) => {
        let regexToUse = regexForInputs["phoneNumber"];
        if (countryCodeVal != "+91") {
            regexToUse = /^[1-9][0-9]{6,14}$/;
        }
        if (!regexToUse.test(value)) {
            setErrors((prev) => ({
                ...prev,
                phoneNumber: errorAccordingToFieldName["phoneNumber"],
            }));
        } else {
            setErrors((prev) => ({ ...prev, phoneNumber: "" }));
        }
        setFormValues((prev) => ({ ...prev, phoneNumber: value }));
    };

    const handleSingleFieldChange = (
        fieldName: string,
        value: string | boolean
    ) => {
        if (
            (!regexForInputs[fieldName]?.test(value) &&
                fieldName !== "degree" &&
                fieldName !== "program") ||
            value.toString().includes("Select")
        ) {
            setErrors((prev) => ({
                ...prev,
                [fieldName]: errorAccordingToFieldName[fieldName],
            }));
        } else {
            setErrors((prev) => ({ ...prev, [fieldName]: "" }));
        }
        setFormValues((prev) => ({ ...prev, [fieldName]: value }));

        // If country code is changed then validate phone number again
        if (fieldName === "countryCode") {
            handlePhoneNumberChange(formValues.phoneNumber, value.toString());
        }

    };

    const checkAllFieldsValid = () => {

      if(isCampusImmersionPage){

        return (
          formValues.fullName !== "" &&
          formValues.phoneNumber !== "" &&
          formValues.emailId !== "" &&
          formValues.isTermsAccepted &&
          formValues.workExperience !== "" &&
          Object.values(errors).every((x) => x === "")
        )
      }
        return (
            formValues.fullName !== "" &&
            formValues.phoneNumber !== "" &&
            formValues.emailId !== "" &&
            formValues.isTermsAccepted &&
            Object.values(errors).every((x) => x === "")
        )
    };

    const resetState = ()=>{
      setIsHeaderHidden(false)
      setApplicationRedirectLoaderDisabled(true)
      setFormValues({
        fullName: "",
        countryCode: "+" + ipStackDetails?.location?.calling_code || "91",
        phoneNumber: "",
        emailId: "",
        programId: props.ProgramId,
        isTermsAccepted: true,
        workExperience: ""
      });
      setLoadingCount(3)
    }
    
    const startLoader = (prospectId : string) => {
      counterInterval.current = setInterval(() => {
        setLoadingCount((count) => {
          if (count < 1) {
            clearInterval(counterInterval.current);

            window.location.href =`/thankyou?prospectId=${prospectId}`;
            StorageService.set("emailEvent", formValues.emailId);

            setTimeout(() => {
              resetState();
            }, 1500);
            
            return 0;
          } else {
            return count = count - 1;
          }
        });
      }, 1000);
    };

    const handleSubmit = (payload) => {

        const form = {
          name: payload.fullName,
          phone: payload.phoneNumber,
          countryCode: payload.countryCode,
          email: payload.emailId,
          PROGRAM_ID: getProgramId({
            programId: props.ProgramId,
            associatedPrograms: props.associatedPrograms,
          }),
          Custom6: getSpecializationValue({ associatedPrograms: props.associatedPrograms }),
          consent: true,
        };

        if(isCampusImmersionPage){
          form['WorkExperience'] = payload.workExperience
        }

        const tracking = trackingDetails();
        
        const newMetaObj =  props?.isWebinar ?  {utm_source: tracking?.utm_source || "Zoom Webinar" } :{}
        const leadSquareApiCall = (payload: any) =>
          fetch("/api/leadsquared.com/lead-create-lp", {
            method: "POST",
            body: JSON.stringify({
              ipstack: ipStackDetails,
              form: { ...form, ...payload },
              meta: {
                ...tracking,
                ...newMetaObj,
                utm_campaign: props?.isWebinar
                  ? tracking?.utm_campaign || "Zoom Webinar"
                  : tracking?.utm_campaign,
                utm_medium: props?.isWebinar
                  ? tracking?.utm_medium || "Zoom Webinar"
                  : tracking?.utm_medium || "request_a_callback",
              },
            }),
          });

        const verifyOtpCb = async ( prospectId: string ) => {
           
            if( window.location.pathname === "/lp-nw/scholarship-notification" ){
              setIsThankYouBannerHidden(false)
            }
            else {
              startLoader(prospectId);
              setApplicationRedirectLoaderDisabled(false)
            } 
        };

        const cb = () => {
            return new Promise(async (resolve, reject) => {
              try{
                loading(true); 
                const parts = form?.name.trim().split(" ");
                const firstName = parts[0] || "";
                const lastName = parts[1] || "";
                let zoomform={
                    email: form?.email,
                    firstName:  firstName, 
                    lastName: lastName,
                    phone: form?.phone,
                    webinarId: webinarId , 
                }
                const leadSquareResponse=await leadSquareApiCall({Custom5 : "Not Verified", Custom10: Custom10Value || "",...(props.isWebinar && { Custom2: "Zoom Webinar"  })});
                const resp = await leadSquareResponse.json();

                pushToDataLayer({
                  "event" : "MFilter_OTP_Verified_New",
                  "LSQ_ID" : resp?.response?.ProspectId
              })
              document.addEventListener("mfilterit:botDetect", getEvent)
                    StorageService.set("LSQ_ID", resp?.response?.ProspectId)
                    updateStateSession({
                      formSectionName : "Apply Now"
                    })
                    pushToDataLayer({
                      event: "lead_submit",
                      cta_text: "Submit",
                      lead_starting_cta: props?.isWebinar?"Reserve your spot":"Enquire Now",
                      lead_starting_url : window.location.href || "NA",
                      lead_id : resp?.response?.ProspectId|| "NA",
                      section_name : getGlobalStateValue('parentSection') || "NA",
                      status: "success",
                      error_message: "NA",
                      lead_type: "lead_submit_1",
                      page_type : getGlobalStateValue('pageType'),
                      email_id: form.email,
                      page_url : window?.location?.href || "NA"
                    });

                     window.webengage.track("Lead Form Filled", {
                          "Student Nationality": payload.countryCode == "+91" ? "National" : "International",
                          "First Name": payload.fullName,
                          "Phone Number": payload.countryCode + payload.phoneNumber,
                          "Email ID": payload.emailId,
                          "Form Type":"Apply",
                          "Section Name": getGlobalStateValue('parentSection') || "",
                          "Application URL": resp?.response?.URL || "",
                      }) 

                const zoomApiCall = await fetch("/api/zoom-call", {
                  method: "POST",
                  body: JSON.stringify(
                    zoomform
                  ),
                });

                const zoomApiCallResponse = await zoomApiCall.json();
                const zoomData = zoomApiCallResponse?.data || {};
                let ZoomStatus = zoomData?.success !== undefined ? zoomData?.success : zoomData?.status
                const connectCounsellorApiCall = fetch("/api/connect-counsellor", {
                    method: "POST",
                    body: JSON.stringify({
                        ipstack: ipStackDetails,
                        form,
                        status: true,
                        zoomApiCallResponse,
                        ZoomStatus,
                        isWebinar: props.isWebinar || false,
                        ApiRequest: {form,ipstack: ipStackDetails, tracking, Custom10Value},
                        meta: {
                            ...tracking,
                            utm_medium:props.isWebinar?"Zoom Webinar" :tracking?.utm_medium || "request_a_callback",
                            // program: programDetails.Heading,
                            // programLevel: programDetails.ProgramType,
                        },
                    }),
                });
                await connectCounsellorApiCall;
                if(resp?.success) {
                  apiResponseURL.current =resp?.response?.URL || "";
                  
                  if (formValues?.countryCode !== "+91") { 
                    startLoader(resp?.response?.ProspectId)
                    setApplicationRedirectLoaderDisabled(false)
                    return
                  }
                 
                  setLeadResponse(resp?.response)
                  setIsHeaderHidden(true)
                  resolve(resp?.response)
            
                
                } else {
                  setShowLoader(false);
                  const errorMessage = "Error occurred.";
                  pushToDataLayer({
                    event: "lead_submit",
                    cta_text: "Submit",
                    lead_starting_cta: "NA",
                    lead_starting_url : window.location.href || "NA",
                    lead_id : "NA",
                    section_name : getGlobalStateValue('parentSection') || "NA",
                    status: "fail",
                    error_message: errorMessage,
                    lead_type: "lead_submit_1",
                    page_type : getGlobalStateValue('pageType'),
                    email_id: form.email,
                    page_url : window?.location?.href || "NA"
                  });
                  setMessage(errorMessage);
                  reject(new Error(errorMessage));
                }

              }
              catch(error){
                setShowLoader(false);
                pushToDataLayer({
                  event: "lead_submit",
                  cta_text: "Submit",
                  lead_starting_cta: "NA",
                  lead_starting_url : window.location.href || "NA",
                  lead_id : "NA",
                  section_name : getGlobalStateValue('parentSection') || "NA",
                  status: "fail",
                  error_message: error,
                  lead_type: "lead_submit_1",
                  page_type : "Campaign Page",
                  email_id: form.email,
                  page_url : window?.location?.href || "NA"
                });
                reject(error); 
              }
               finally{
                loading(false)
               }
                function getEvent(event) {
                    StorageService.set("mFitlerKeyDetails", event.detail)
                }
           
            });
        };
  
        handleSendOTP(form, cb, null, verifyOtpCb);
    };
    const makeFormSubmission = useCallback(
        (e: any) => {
            e.preventDefault();
            const isValid = checkAllFieldsValid();
            if (isValid) {
                handleSubmit(formValues);
                
            }
        },
        [formValues]
    );

    useEffect(() => {
        return ()=>{
            clearInterval(counterInterval.current)
        }
    }, []);

    useEffect(() => {
        const isFormValid = checkAllFieldsValid();
        setIsFormValid(isFormValid);
    }, [formValues]);


    const handleFieldBlur = (fieldName: string, value: string, error: string | undefined) => {
      pushToDataLayer({
        'event': 'form_filled',
        'field_name': fieldName,
        'option_selected': value || "NA",
        'error_message': error || "NA",
        'section_name': getGlobalStateValue('parentSection') || "NA",
        'page_type' : getGlobalStateValue('pageType'),
			  'page_url' : window?.location?.href || "NA"
      });
    };
    const updateCountryCode = (value) => {
      const newFormValues  = { ...formValues }
      newFormValues['countryCode'] = value;
      newFormValues['phoneNumber'] = "";
      setFormValues(newFormValues);
    }
    useEffect(()=>{
      sessionStorage.setItem('isWebinar', props?.isWebinar?"true":"false")
    },[props?.isWebinar])
  
    return (
      <div id="#leadform" className={cn( styles.root,"h-full flex flex-col justify-between",{ [styles.greyBackground]: props.isWebinar },{[styles.whiteBackground]:props.isModal} )}>
        {!isApplicationRedirectLoaderDisabled ? (
          <div className={styles.applicationLoader}>
            <ApplicationFormRedirectLoader redirectTime={loadingCount} text=""/>
          </div>
        ) : !isThankYouBannerHidden ? 
          <ThankyouForInterestSection />
          :
          <form
            ref={setRefs}
            onSubmit={makeFormSubmission}
          >
            {!isHeaderHidden && <Markdown className={styles.formHeading}>{props.isWebinar?"Reserve Your Spot":"Enquire Now"}</Markdown>}
            <div className={cssConfig.formWrapper}>
              <div className={cssConfig.firstName}>
                <div className={isCampusImmersionPage ? styles.widthInputboxFirstName : "w-[100%]"}>
                  <label htmlFor="input">
                    full name<span className="text-xl">*</span>
                  </label>
                  <Input
                    placeholder="Enter your full name"
                    value={formValues.fullName}
                    onChangeFunc={(value: string) => handleSingleFieldChange("fullName", value)}
                    onBlur={() => handleFieldBlur("fullName", "", errors.fullName)}
                  />
                  <p className={cn(styles.error)}>{errors.fullName}</p>
                </div>
                <div className={isCampusImmersionPage ? styles.widthInputbox : "hidden"}>
                  <label htmlFor="input">
                    Work Experience<span className="text-xl">*</span>
                  </label>
                  <div>
                      <Select
                        isFullWidth={true}
                        value={formValues.workExperience}
                        onChangeFunc={(value: string) =>
                          handleSingleFieldChange("workExperience", value)
                        }
                        options={EXPERIENCE_LIST}
                        disabled={disabledButton}
                      />
                    </div>
                    <p className={cn(styles.error)}>{errors.workExperience}</p>
                </div>


              </div>
              <div className={cssConfig.phoneNumber}>
                <div className="w-[100%]">
                  <label htmlFor="input">
                    phone number <span className="text-xl">*</span>
                  </label>
                  <div className="flex gap-[6px]">
                    <div className={`${props?.isWebinar?"mt-1 lg:mt-2":""}`}>
                      {props.isWebinar?
                    ( <CountryDropdownGlobal
                      onChangeFunc={(value: string) => handleSingleFieldChange("countryCode", value)}
                      countries={ALL_COUNTRIES}
                      countryCode={formValues.countryCode}
                      updateCountryCode={updateCountryCode}
                      additionalStyle="h-[2.75rem] lg:h-[2.25rem]"
                      isDark={false}
                                  />)
                                  :(
                                     <Select
                                    isFullWidth={false}
                                    value={formValues.countryCode}
                                    onChangeFunc={(value: string) =>
                                      handleSingleFieldChange("countryCode", value)
                                    }
                                    options={countryCodeOptions}
                                    disabled={disabledButton}
                                  />
                                   )}
                    </div>
                    <div className="w-full">
                      <Input
                        placeholder="Enter your no."
                        value={formValues.phoneNumber}
                        onChangeFunc={handlePhoneNumberChange}
                        onBlur={() => handleFieldBlur("phoneNumber", "", errors.phoneNumber)}
                      />
                    </div>
                  </div>
                  <p className={cn(styles.error)}>{errors.countryCode || errors.phoneNumber}</p>
                </div>
              </div>

              <div className={cssConfig.email}>
                <div className="w-[100%]">
                  <label htmlFor="input">
                    email id <span className="text-xl">*</span>
                  </label>
                  <Input
                    placeholder="abc@xyz.com"
                    value={formValues.emailId}
                    onChangeFunc={(value: string) => handleSingleFieldChange("emailId", value)}
                    onBlur={() => handleFieldBlur("emailId", "", errors.emailId)}
                  />
                  <p className={cn(styles.error)}>{errors.emailId}</p>
                </div>
              </div>
            </div>

            <div className={cssConfig.termsConditions}>
              <div className="shrink-0">
                <Checkbox
                  name="consent"
                  value={formValues.isTermsAccepted}
                  onChangeFunc={(value: boolean) =>
                    handleSingleFieldChange("isTermsAccepted", value)
                  }
                  onBlur={() => handleFieldBlur("isTermsAccepted", "", errors?.isTermsAccepted || "NA")}
                />
              </div>
              <p className={cn(styles.authorization)}>
              <ConsentFormPara/>
              </p>
            </div>

            {/* <p className={cn(styles.error)}>{errors.degree}</p> */}

            <SubmitButton
              text={isLoading || isOTPLoading ? "Submitting" : "Submit"}
              isDisabled={isLoading || isOTPLoading || !isFormValid}
              bgColor={btnColors.bg}
              textColor={btnColors.color}
            />
            {message && message}
          </form>
        }
      </div>
    );
}

